<template>
  <div class="upload-img" :style="{'backgroundImage': `url(${bgImg})`}">
    <a-upload
      :accept="accept"
      :multiple="true"
      list-type="picture-card"
      class="card-uploader"
      :show-upload-list="false"
      @change="onChange"
      :customRequest="uploadRequest"
    >
      <div></div>
    </a-upload>
  </div>
</template>

<script>
import { getRandom, getBase64 } from '@/utils/util.js'
import { mapActions } from 'vuex'
import * as qiniu from 'qiniu-js'
export default {
  components: {
  },
  props: {
    bucketType: {
      type: String,
      default: '1' //	1:正常图片  2：水印图片  3：私用空间 4. 用户资源
    },
    path: {
      type: String,
      default: 'resources/contributeInfo_web/'
    },
    isWaterMark: {
      type: Boolean,
      default: false
    },
    bgImg: {
      type: String,
      default: require('../../../assets/img/img_upload_120@2x.png')
    },
    accept: {
      type: String,
      default: '.jpeg,.png,.jpg'
    },
    limit: {
      type: Number, // 单位 kb
      default: 0
    },
    lengthLimit: {
      type: Object,
      default: () => {
        return {
          length: 30,
          errorText: '已经上传30张素材了，不可以上传新素材了哦'
        }
      }
    },
    checkSize: {
      type: Function,
      default: () => {
        return new Promise((resolve, reject) => {
          resolve('OK')
        })
      }
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    category: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      uploadTimer: null
    }
  },
  methods: {
    ...mapActions(['getQiniuToken']),
    name () {
      return getRandom(4) + Math.floor(new Date().getTime() / 1000) + getRandom(4)
    },
    onChange ({ file, fileList }) {
      // this.$emit('onChange', file)
      if (this.dataList.length >= this.lengthLimit.length) {
        if (this.uploadTimer) {
          clearTimeout(this.uploadTimer)
        }
        this.uploadTimer = setTimeout(() => {
          this.uploadTimer = null
          this.$message.error(this.lengthLimit.errorText)
        }, 500)
        return false
      }
      this.dataList.push(
        Object.assign(
          {
            width: '',
            height: '',
            loading: false,
            percent: 0,
            title: '', // file.name.split('.')[0].substring(0, 8)
            error: '',
            errorType: [],
            image: '',
            watermark_image: ''
          },
          file
        )
      )

      const last = this.dataList.length - 1
      const typeList = this.accept
      const isJpgOrPng = typeList.split(',').findIndex((item) => {
        return file.type.indexOf(item.replace(/\./g, '')) > -1
      })
      if (isJpgOrPng < 0) {
        this.dataList[last].errorType.push('1')
      }

      if (this.limit) {
        const isLimit = file.size / 1024 < this.limit
        if (!isLimit) {
          this.dataList[last].errorType.push('2')
        }
      }
      this.checkElementSize(this.dataList[last].originFileObj, this.dataList[last])
        .then(async (res) => {
          if (this.dataList[last].errorType.length === 0) {
            await this.postImage(this.dataList[last], this.path)
            if (this.isWaterMark) {
              await this.addWaterMark(this.dataList[last], this.path)
            }
            this.dataList[last].loading = false
            this.$emit('uploadSuccess')
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          console.log(this.dataList[last])
          if (this.dataList[last].errorType.length > 0) {
            const errorMap = {
              '1': '格式',
              '2': '大小',
              '3': '尺寸'
            }
            const text = this.dataList[last].errorType.map(item => {
              return errorMap[item]
            }).join('、')
            this.dataList[last].error = `${text}有误，请重新上传`
          }
        })
    },
    async uploadRequest ({ action,
      data,
      file,
      filename,
      headers,
      onError,
      onProgress,
      onSuccess,
      withCredentials }) {

    },
    // 上传前检测尺寸是否符合
    checkElementSize (file, scopeData) {
      return new Promise((resolve, reject) => {
        getBase64(file, (oImg) => {
          const img = new Image()
          img.src = oImg
          console.log(oImg)
          img.onerror = (e) => {
            console.log(e)
            const err = 'err'
            reject(err)
          }
          img.onload = () => {
            scopeData.width = img.width
            scopeData.height = img.height
            if (this.category == '1') {
              // 如果是场景 height 小于1600
              if (img.height > 1600) {
                if (scopeData.image) {
                  this.$message.error('只能上传高度小于1600像素的图片')
                } else {
                  scopeData.error = '尺寸有误，请重新上传'
                  scopeData.errorType.push('3')
                }
                const err = 'err'
                reject(err)
              } else {
                resolve('ok')
              }
            } else if (this.category == '2') {
              // 如果是贴图  width < 640 && height < 800
              if (img.width > 1000 || img.height > 1000) {
                if (scopeData.image) {
                  this.$message.error('只能上传1000×1000像素以内的图片')
                } else {
                  scopeData.error = '尺寸有误，请重新上传'
                  scopeData.errorType.push('3')
                }
                const err = 'err'
                reject(err)
              } else {
                resolve('ok')
              }
            }
          }
        })
      })
    },
    // 上传到七牛
    async postImage (file, path) {
      return new Promise(async (resolve, reject) => {
        const sendData = {
          action: 'upload',
          bucketType: '1'
        }
        // 获取七牛上传token
        await this.getQiniuToken(sendData)

        const params = {
          token: this.$store.state.texture.token,
          key: `${path}${this.name()}.${file.type.split('/')[1]}`
        }
        file.loading = true
        // 上传到七牛 拿到图片地址
        const observable = qiniu.upload(file.originFileObj, params.key, params.token)
        observable.subscribe({
          next: (result) => {
          // 主要用来展示进度
            file.percent = Math.round(result.total.percent).toFixed(0)
          // if (file.percent === 100) {
          //   file.loading = false
          // }
          // this.$emit('onChange', this.file)
          },
          error: () => {
            this.$message.error('上传图片失败')
            reject(new Error('上传图片失败'))
          },
          complete: async (response) => {
            file.image = response.key // 返回的路径
            resolve(response)
          // file.loading = false
          }
        })
      })
    },
    // 添加水印
    async addWaterMark (file, path) {
      return new Promise(async (resolve, reject) => {
        // 生成水印名字
        const waterMarkKey = `${path}${this.name()}.${file.originFileObj.type.split('/')[1]}`
        // 上传水印图片
        const sendData = {
          action: 'upload',
          bucketType: '2'
        }
        await this.getQiniuToken(sendData)

        // 上传到七牛 拿到图片地址
        const observable = qiniu.upload(file.originFileObj, waterMarkKey, this.$store.state.texture.token)
        observable.subscribe({
          next: (result) => {
          // 主要用来展示进度
          },
          error: () => {
            this.$message.error('上传水印图片失败')
            reject(new Error('上传水印图片失败'))
          },
          complete: (response) => {
            file.watermark_image = response.key // 返回的路径
            resolve(response)
          }
        })
      })
    }
  }

}
</script>

<style scoped lang="less">

.upload-img{
  background-size: 100% 100%;
    background-color: #fafafa;
    background-image: url('../../../assets/img/material_bg.jpg');
    background-repeat: no-repeat;
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    border: 1px dashed #E5E5E5;
    &:hover {
      border-color: @primary-color;
    }
    &:hover {
      .mask {
        display: flex;
        /deep/
        .upload-btn {
          padding: 0;
          display: block;
          width: 75px;
          height: 30px;
        }
      }
    }
    img {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      border-radius: 8px;
     height: auto;
    }
    .process-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 25px;
      .process {
        width: 100%;
        border-radius: 8px;
        border:1px solid @primary-color;
        padding: 0 5px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        height: 16px;
        .wrap-in {
          width: 20%;

          border-radius: 4px;
          height: 8px;
          background-color: @primary-color;
        }
      }
    }
    .mask {
      pointer-events: none;
        display: none;
        position: absolute;
        border-radius: 4px;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);

        justify-content: center;
        align-items: center;
    }
    /deep/
    .card-uploader > .ant-upload {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      overflow: hidden;
    }
    /deep/
    .ant-upload.ant-upload-select-picture-card > .ant-upload{
      border-radius: 8px;
      padding: 0;
    }
    /deep/
    .ant-upload.ant-upload-select-picture-card {
      background: none;
    }
    /deep/
    .ant-upload-picture-card-wrapper {
      height: 100%;
    }

}
</style>
